import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "pinwallList",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/PinwallList.vue")
    },
    {
      name: "search",
      path: "/search",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Search.vue")
    },
    {
      name: "profile",
      path: "/profile",

      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/Profile.vue")
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/terms",
      name: "terms",
      component: () =>
        import(/* webpackChunkName: "terms" */ "./views/Terms.vue")
    },
    {
      path: "/privacypolicy",
      name: "privacy",
      component: () =>
        import(/* webpackChunkName: "terms" */ "./views/Privacy.vue")
    },
    {
      path: "/cookiespolicy",
      name: "cookies",
      component: () =>
        import(/* webpackChunkName: "terms" */ "./views/Cookies.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "terms" */ "./views/Contact.vue")
    },
    {
      path: "/tenant",
      name: "tenant",
      component: () =>
        import(/* webpackChunkName: "tenants" */ "./views/Tenant.vue")
    },
    {
      path: "/settings",
      name: "settings",
      component: () =>
        import(/* webpackChunkName: "settings" */ "./views/Settings.vue")
    },
    {
      name: "pinwallListWithTenant",
      path: "/:tenant",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/PinwallList.vue")
    },
    {
      name: "profileWithTenant",
      path: "/:tenant/profile",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/Profile.vue")
    },
    {
      name: "termsWithTenant",
      path: "/:tenant/terms",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/Terms.vue")
    },
    {
      name: "termsWithTenant",
      path: "/:tenant/privacypolicy",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/Privacy.vue")
    },
    {
      name: "termsWithTenant",
      path: "/:tenant/cookiespolicy",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/Cookies.vue")
    },
    {
      name: "contactWithTenant",
      path: "/:tenant/contact",

      component: () =>
        import(/* webpackChunkName: "pinwallList" */ "./views/Contact.vue")
    },
    {
      name: "searchWithTenant",
      path: "/:tenant/search",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Search.vue")
    },
    {
      path: "/:tenant/tenant",
      name: "/tenantWithTenant",
      component: () =>
        import(/* webpackChunkName: "tenants" */ "./views/Tenant.vue")
    },
    {
      path: "/:tenant/settings",
      name: "/settingsWithTenant",
      component: () =>
        import(/* webpackChunkName: "settings" */ "./views/Settings.vue")
    },
    {
      name: "pinwall",
      path: "/:space/:pinwallId",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Pinwall.vue")
    },
    // {
    //   name: "comment",
    //   path: "/:space/:pinwallId/comment",
    //   component: () =>
    //     import(/* webpackChunkName: "pinwall" */ "./views/Comment.vue"),
    // },
    // {
    //   name: "screen",
    //   path: "/:space/:pinwallId/screen",
    //   component: () =>
    //     import(/* webpackChunkName: "pinwall" */ "./views/Screen.vue"),
    // },
    // {
    //   name: "add",
    //   path: "/:space/:pinwallId/add",
    //   component: () => import(/* webpackChunkName: "add" */ "./views/Add.vue"),
    // },
    {
      name: "pinwallWithTenant",
      path: "/:tenant/:space/:pinwallId",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Pinwall.vue")
    },
    {
      name: "screenWithTenant",
      path: "/:tenant/:space/:pinwallId/screen",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Screen.vue")
    },
    {
      name: "commentWithTenant",
      path: "/:tenant/:space/:pinwallId/comment",
      component: () =>
        import(/* webpackChunkName: "pinwall" */ "./views/Comment.vue")
    },
    {
      name: "addWithTenant",
      path: "/:tenant/:space/:pinwallId/add",
      component: () => import(/* webpackChunkName: "add" */ "./views/Add.vue")
    }
  ]
});
